import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <div className="footer">
      <div className="container text-center">
        <p className="text-muted small mb-0">
          Derechos Reservados &copy; Alejandra Cardenas, Myriam Lizeth Niño Joya, Katty Gomez Acevedo, Javier Andrés Román Osorio & Juan Sebastian Rubiano Jara 2021.
        </p>
        <p className="text-muted small mb-0">
          Desarrollado para MisiónTIC 2022. Ciclo 3.
        </p>
      </div>
    </div>
  );
};

export default Footer;